import React, { useRef, useState } from "react";
import styles from "./profileComp.module.scss";
import { useProfile } from "../../../../context/ProfileContext";
import Icon from "../../../../components/Icon";

export const interestData = [
  "Sports",
  "Books",
  "Gym",
  "Running",
  "Tech",
  "Travel",
  "Games",
  "Video Games",
  "Photography",
  "Cooking",
  "Drawing",
  "Music",
  "Art & Crafts",
  "Writing",
];

const BasicInfo = () => {
  const {
    profileInfo,
    handleFocus,
    current,
    handleChange,
    setProfileInfo,
    updatedField,
    handleSubmit,
    handleDiscard,
  } = useProfile();
  const [showOptions, setShowOptions] = useState<boolean>(false);
  const [previousValue, setPreviousValue] = useState<string>("");
    const getRole = () => {
      return localStorage.getItem("Role");
    };
  return (
    <div
      className={`${
        current?.section === "basicInfo"
          ? `${styles.editing}`
          : current?.section === ""
          ? `${styles.neutral} `
          : null
      } ${styles.InfoContainer}`}
    >
      <div className={styles.Header}>
        <h3>Basic Information</h3>

        {current?.section === "basicInfo" && (
          <div className={styles.headerStatus}>
            <Icon name="edit" width={15} height={15} className={styles.edits} />
            <p>editing</p>
          </div>
        )}
      </div>

      <div>
        <label htmlFor="firstName" className={styles.labels}>
          First Name
        </label>
        <div className={styles.contBoxes}>
          <div
            className={`${styles.inputContainer}  ${
              updatedField?.fieldName === "firstName" ? styles.editingField : null
            }`}
          >
            <input
              id="firstName"
              type="text"
              className={`${styles.basicInputs}`}
              onChange={handleChange}
              name="firstName"
              value={profileInfo?.firstName}
              placeholder="First Name"
              onFocus={() => {
                return handleFocus("firstName", "basicInfo");
              }}
            />

            <div>
              <Icon name="edit" width={20} height={20} className={styles.edits} />
            </div>
          </div>
          {(current?.fieldName === "firstName" || updatedField?.fieldName === "firstName") && (
            <div className={styles.saves}>
              <button
                className={styles.save}
                onClick={(e: any) => {
                  handleSubmit(e, "firstName");
                }}
              >
                Save
              </button>
              <button className={styles.discard} onClick={() => handleDiscard("firstName")}>
                Discard
              </button>
            </div>
          )}
        </div>
      </div>
      <div>
        <label htmlFor="lastName" className={styles.labels}>
          Last Name
        </label>
        <div className={styles.contBoxes}>
          <div
            className={`${styles.inputContainer}  ${
              updatedField?.fieldName === "lastName" ? styles.editingField : null
            }`}
          >
            <input
              id="lastName"
              type="text"
              className={styles.basicInputs}
              onChange={handleChange}
              name="lastName"
              value={profileInfo?.lastName}
              placeholder="Last Name"
              onFocus={() => {
                handleFocus("lastName", "basicInfo");
              }}
            />
            <div>
              <Icon name="edit" width={20} height={20} className={styles.edits} />
            </div>
          </div>

          {(current?.fieldName === "lastName" || updatedField?.fieldName === "lastName") && (
            <div className={styles.saves}>
              <button className={styles.save} onClick={(e: any) => handleSubmit(e, "lastName")}>
                Save
              </button>
              <button className={styles.discard} onClick={() => handleDiscard("lastName")}>
                Discard
              </button>
            </div>
          )}
        </div>
      </div>
      <div>
        <label htmlFor="otherNames" className={styles.labels}>
          Other Names
        </label>
        <div className={styles.contBoxes}>
          <div
            className={`${styles.inputContainer}  ${
              updatedField?.fieldName === "otherNames" ? styles.editingField : null
            }`}
          >
            <input
              id="otherNames"
              type="text"
              className={styles.basicInputs}
              onChange={handleChange}
              name="otherNames"
              value={profileInfo?.otherNames}
              placeholder="Other Names"
              onFocus={() => {
                handleFocus("otherNames", "basicInfo");
              }}
            />
            <div>
              <Icon name="edit" width={20} height={20} className={styles.edits} />
            </div>
          </div>
          {(current?.fieldName === "otherNames" || updatedField?.fieldName === "otherNames") && (
            <div className={styles.saves}>
              <button className={styles.save} onClick={(e: any) => handleSubmit(e, "otherNames")}>
                Save
              </button>
              <button className={styles.discard} onClick={() => handleDiscard("otherNames")}>
                Discard
              </button>
            </div>
          )}
        </div>
      </div>
      <div>
        <label htmlFor="email" className={styles.labels}>
          Email
        </label>
        <div
          className={`${styles.inputContainer}  ${
            updatedField?.fieldName === "email" ? styles.editingField : null
          }`}
        >
          <input
            id="email"
            type="email"
            className={styles.basicInputs}
            readOnly
            name="email"
            value={profileInfo?.email}
            placeholder="Email"
          />
        </div>
      </div>
      {getRole()?.toLocaleLowerCase() === "teacher" && (
        <div className={styles.contBoxes}>
          <label htmlFor="interest" className={styles.labels}>
            Interests
          </label>
          {/* the selected Interests */}
          <div
            className={`${styles.inputContainer}  ${
              updatedField?.fieldName === "interest" ? styles.editingField : null
            }`}
            id="interests"
          >
            <div className={styles.interests}>
              {profileInfo?.interests?.map((interest, index) => (
                <div
                  key={index}
                  className={styles.item}
                  onClick={() => {
                    handleFocus("interest", "basicInfo");
                    const newInterests = [...profileInfo.interests];
                    newInterests.splice(index, 1);
                    setProfileInfo({ ...profileInfo, interests: newInterests });
                  }}
                >
                  <p className={styles.pInterest}>{interest}</p>
                  <Icon name="close" width={10} height={10} className={styles.close} />
                </div>
              ))}
            </div>
            <div onClick={() => handleFocus("interest", "basicInfo")}>
              {/* <Icon name="edit" width={20} height={20} className={styles.add} /> */}
              <button onClick={() => setShowOptions(!showOptions)}>Change</button>
            </div>
          </div>

          {/* the options */}
          {showOptions && (
            <div className={styles.interestOptions}>
              {interestData?.map((item, index) => (
                <div
                  key={index}
                  className={styles.item}
                  onClick={() => {
                    handleFocus("interest", "basicInfo");

                    const newInterests = [...(profileInfo?.interests || [])];
                    newInterests.push(item);
                    setProfileInfo((prevProfile) =>
                      prevProfile ? { ...prevProfile, interests: newInterests } : null
                    );
                  }}
                >
                  <p className={styles.pInterest}>{item}</p>
                  <Icon name="add" width={10} height={10} className={styles.close} />
                </div>
              ))}
            </div>
          )}

          {(current?.fieldName === "interest" || updatedField?.fieldName === "interest") && (
            <div className={styles.saves}>
              <button className={styles.save} onClick={(e: any) => handleSubmit(e, "interests")}>
                Save
              </button>
              <button
                className={styles.discard}
                onClick={() => {
                  setShowOptions(false);
                  handleDiscard("interests");
                }}
              >
                Discard
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default BasicInfo;
